// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KVG_F59xlQXFW3EAsHF_ {
  position: fixed;
  top: 0;
  left: 340px;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 24px 40px;
  background: #FCFCFC;
  box-shadow: inset 1px 0px 0px #F4F4F4, inset 0 -1px 0px #EFEFEF;
}
@media only screen and (max-width: 1339px) {
  .KVG_F59xlQXFW3EAsHF_ {
    left: 300px;
    padding: 16px 24px;
  }
}
@media only screen and (max-width: 1259px) {
  .KVG_F59xlQXFW3EAsHF_ {
    left: 96px;
  }
}
@media only screen and (max-width: 767px) {
  .KVG_F59xlQXFW3EAsHF_ {
    left: 0;
    padding: 16px 24px 16px 16px;
  }
}
.dark-mode .KVG_F59xlQXFW3EAsHF_ {
  background: #1A1D1F;
  box-shadow: inset 1px 0px 0px #111315, inset 0 -1px 0px #111315;
}

.lbcBthzL0szbNtjpaqF2 {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  margin-right: auto;
}
@media only screen and (max-width: 767px) {
  .lbcBthzL0szbNtjpaqF2 {
    display: flex;
  }
}
.lbcBthzL0szbNtjpaqF2:before, .lbcBthzL0szbNtjpaqF2:after {
  content: "";
  width: 16px;
  height: 2px;
  border-radius: 2px;
  background: #6F767E;
}
.lbcBthzL0szbNtjpaqF2:before {
  margin-bottom: 6px;
}

.P3M7_n8ti2nQoFqXBRPQ {
  display: flex;
  align-items: center;
  margin-left: auto;
}
@media only screen and (max-width: 767px) {
  .P3M7_n8ti2nQoFqXBRPQ {
    margin-left: 0;
  }
}

.P3M7_n8ti2nQoFqXBRPQ .ONORJGS1PBu3vwHLcYwq:not(:last-child),
.P3M7_n8ti2nQoFqXBRPQ > div:not(:last-child),
._KAKxq7kbbfpOq2h71VV:not(:last-child) {
  margin-right: 24px;
}

._KAKxq7kbbfpOq2h71VV {
  display: none;
  width: 48px;
  height: 48px;
}
@media only screen and (max-width: 767px) {
  ._KAKxq7kbbfpOq2h71VV {
    display: inline-block;
  }
}
._KAKxq7kbbfpOq2h71VV svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
._KAKxq7kbbfpOq2h71VV.ELRvKBPrj6Qolm5iDgLL svg {
  fill: #1A1D1F;
}
.dark-mode ._KAKxq7kbbfpOq2h71VV.ELRvKBPrj6Qolm5iDgLL svg {
  fill: #FCFCFC;
}

@media only screen and (max-width: 1023px) {
  .P3M7_n8ti2nQoFqXBRPQ .ONORJGS1PBu3vwHLcYwq {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .ctKj4rMKgLAagdzWkRa9 {
    visibility: hidden;
    opacity: 0;
    transition: all 0.2s;
  }
  .ctKj4rMKgLAagdzWkRa9.IKimBjAg9Gq100srEofR {
    visibility: visible;
    opacity: 1;
  }
}

.EqlD3UfKWAWhGQW772ms {
  display: flex;
  align-items: center;
  margin-left: auto;
}
@media only screen and (max-width: 767px) {
  .EqlD3UfKWAWhGQW772ms {
    margin-left: 0;
  }
}

.x34yzBcK959vD3i6iGDL {
  margin-right: 32px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.6;
  color: #1A1D1F;
  transition: color 0.2s;
}
@media only screen and (max-width: 767px) {
  .x34yzBcK959vD3i6iGDL {
    margin-right: 24px;
  }
}
.dark-mode .x34yzBcK959vD3i6iGDL {
  color: #FCFCFC;
}

.x34yzBcK959vD3i6iGDL:hover {
  color: #2A85FF;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBC8BC;ED7BD,+DAAA;AADJ;ACJI;EDLJ;IAYQ,WAAA;IACA,kBAAA;EACN;AACF;ACPI;EDRJ;IAeQ,UAAA;EAIN;AACF;ACNI;EDdJ;IAiBQ,OAAA;IACA,4BAAA;EAON;AACF;ACgKa;EDtKL,mBCyBH;EDxBG,+DAAA;AASR;;AAPA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAUJ;AC1BI;EDSJ;IASQ,aAAA;EAYN;AACF;AAZI;EAEI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBCGH;ADUL;AAZI;EACI,kBAAA;AAcR;;AAZA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AAeJ;AC/CI;ED6BJ;IAKQ,cAAA;EAiBN;AACF;;AAbI;;;EACI,kBAAA;AAkBR;;AAhBA;EACI,aAAA;EACA,WAAA;EACA,YAAA;AAmBJ;AChEI;ED0CJ;IAKQ,qBAAA;EAqBN;AACF;AArBI;EACI,aCrBH;EDsBG,qBAAA;AAuBR;AArBQ;EACI,aCtBP;AD6CL;ACgGa;EDrHG,aC9BX;ADsDL;;AClFI;ED4DJ;IAEQ,aAAA;EAyBN;AACF;;ACrFI;ED6DJ;IAEQ,kBAAA;IACA,UAAA;IACA,oBAAA;EA2BN;EA1BM;IACI,mBAAA;IACA,UAAA;EA4BV;AACF;;AA3BA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AA8BJ;ACvGI;EDsEJ;IAKQ,cAAA;EAgCN;AACF;;AA/BA;EACI,kBAAA;ECoCA,eAAA;EACA,gBAAA;EACA,gBAAA;EDpCA,cCjDC;EDkDD,sBAAA;AAoCJ;ACrHI;ED6EJ;IAMQ,kBAAA;EAsCN;AACF;ACkDa;EDvFL,cC5DH;ADoGL;;AAvCI;EACI,cCzEH;ADmHL","sourcesContent":["@import ../../styles/helpers\n\n.header\n    position: fixed\n    top: 0\n    left: 340px\n    right: 0\n    z-index: 10\n    display: flex\n    align-items: center\n    padding: 24px 40px\n    background: $n1\n    box-shadow: inset 1px 0px 0px $n2, inset 0 -1px 0px $n3\n    +x\n        left: 300px\n        padding: 16px 24px\n    +d\n        left: 96px\n    +m\n        left: 0\n        padding: 16px 24px 16px 16px\n    +dark\n        background: $n7\n        box-shadow: inset 1px 0px 0px $n8, inset 0 -1px 0px $n8\n\n.burger\n    display: none\n    flex-direction: column\n    justify-content: center\n    align-items: center\n    width: 48px\n    height: 48px\n    margin-right: auto\n    +m\n        display: flex\n    &:before,\n    &:after\n        content: \"\"\n        width: 16px\n        height: 2px\n        border-radius: 2px\n        background: $n4\n    &:before\n        margin-bottom: 6px\n\n.control\n    display: flex\n    align-items: center\n    margin-left: auto\n    +m\n        margin-left: 0\n\n.control .button,\n.control > div,\n.buttonSearch\n    &:not(:last-child)\n        margin-right: 24px\n\n.buttonSearch\n    display: none\n    width: 48px\n    height: 48px\n    +m\n        display: inline-block\n    svg\n        fill: $n4\n        transition: fill .2s\n    &.active\n        svg\n            fill: $n7\n            +dark\n                fill: $n1\n\n.control .button\n    +t\n        display: none\n\n.search\n    +m\n        visibility: hidden\n        opacity: 0\n        transition: all .2s\n        &.visible\n            visibility: visible\n            opacity: 1\n\n.btns\n    display: flex\n    align-items: center\n    margin-left: auto\n    +m\n        margin-left: 0\n\n.link\n    margin-right: 32px\n    +button1\n    color: $n7\n    transition: color .2s\n    +m\n        margin-right: 24px\n    +dark\n        color: $n1\n    &:hover\n        color: $p1\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `KVG_F59xlQXFW3EAsHF_`,
	"burger": `lbcBthzL0szbNtjpaqF2`,
	"control": `P3M7_n8ti2nQoFqXBRPQ`,
	"button": `ONORJGS1PBu3vwHLcYwq`,
	"buttonSearch": `_KAKxq7kbbfpOq2h71VV`,
	"active": `ELRvKBPrj6Qolm5iDgLL`,
	"search": `ctKj4rMKgLAagdzWkRa9`,
	"visible": `IKimBjAg9Gq100srEofR`,
	"btns": `EqlD3UfKWAWhGQW772ms`,
	"link": `x34yzBcK959vD3i6iGDL`
};
export default ___CSS_LOADER_EXPORT___;
